import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * UserProfileApi
 * CRUD operations for the user_profiles table (academic / demographic profile).
 * Endpoint base: /api/user-profiles/{userId}
 */
export const UserProfileApi = {
  /** GET /api/user-profiles/{userId} */
  get: async (userId) => {
    const resp = await fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/user-profiles/${userId}`);
    if (!resp.ok) {
      const error = new Error(`HTTP ${resp.status}`);
      error.status = resp.status;
      error.response = resp;
      throw error;
    }
    return resp.json();
  },

  /** PUT /api/user-profiles/{userId} — create or fully replace */
  save: async (userId, profile) =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/user-profiles/${userId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(profile),
    }),

  /** PATCH /api/user-profiles/{userId} — partial update (creates if missing) */
  patch: async (userId, partial) =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/user-profiles/${userId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(partial),
    }),

  /** DELETE /api/user-profiles/{userId} */
  delete: async (userId) =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/user-profiles/${userId}`, {
      method: 'DELETE',
    }),
};

export default UserProfileApi;
